// keys that scroll the view down, toward the newest content (Space too, unless Shift turns it around)
const SCROLL_DOWN_KEYS = new Set(['ArrowDown', 'PageDown', 'End']);

export const isScrollDownKey = ({ key, shiftKey }) => SCROLL_DOWN_KEYS.has(key) || (key === ' ' && !shiftKey);

// dragging the content down scrolls the view up. Without a known starting point, assume it might.
export const isTouchScrollUp = (previousY, currentY) => previousY === undefined || currentY > previousY;
